export default function extDGZMV(einkommen) {
  return einkommen * 0.0153;
}
